import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, Button } from './ui';
import { ShieldCheck } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 px-6 overflow-hidden bg-cream-light" data-id="element-97">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cream-dark/30 rounded-bl-full -z-10 blur-3xl opacity-50" data-id="element-98"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-sage-light/40 rounded-tr-full -z-10 blur-3xl opacity-50" data-id="element-99"></div>

      <div className="max-w-6xl mx-auto" data-id="element-100">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-101">
          <div className="flex-1 text-center lg:text-left" data-id="element-102">
            <FadeIn data-id="element-103">
              <span className="inline-block py-1 px-3 rounded-full bg-gold-light text-brown-light text-sm font-bold tracking-wider uppercase mb-6" data-id="element-104">
                Para mujeres 50+
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-105">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-106">
                Plan de 21 Días de Vitalidad Menopáusica: <br data-id="element-107" />
                <span className="text-gold italic font-normal" data-id="element-108">
                  El Método de Micro-Sincronización
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-109">
              <p className="text-lg md:text-xl text-brown-light mb-6 max-w-2xl mx-auto lg:mx-0" data-id="element-110">
                Recupera tu energía matutina, elimina la neblina mental y vuelve
                a sentirte dueña de tu cuerpo en solo 3 semanas.
              </p>

              <div className="mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-111">
                <p className="text-sm font-semibold text-brown-light/80 mb-3" data-id="element-112">
                  Diseñado con base en 3 principios validados:
                </p>
                <div className="space-y-1.5 text-sm text-brown-light/70" data-id="element-113">
                  <p className="flex items-start gap-2" data-id="element-114">
                    <span className="text-sage mt-0.5" data-id="element-115">✓</span>
                    Cronobiología circadiana (Dr. Satchin Panda, Salk Institute)
                  </p>
                  <p className="flex items-start gap-2" data-id="element-116">
                    <span className="text-sage mt-0.5" data-id="element-117">✓</span>
                    Eje hormonal cortisol-insulina (investigación
                    post-menopáusica)
                  </p>
                  <p className="flex items-start gap-2" data-id="element-118">
                    <span className="text-sage mt-0.5" data-id="element-119">✓</span>
                    Regulación del nervio vago (neurociencia aplicada)
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-120">
              <div className="mb-8 lg:text-left text-center" data-id="element-121">
                <span className="text-sm text-brown-light uppercase tracking-wider font-bold" data-id="element-122">
                  Inversión única
                </span>
                <div className="flex items-baseline justify-center lg:justify-start gap-3 mt-1" data-id="element-123">
                  <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-124">
                    $19
                  </span>
                  <span className="text-5xl font-bold text-coral" data-id="element-125">$6.39</span>
                  <span className="text-2xl text-brown-light font-normal" data-id="element-126">
                    USD
                  </span>
                </div>
                <span className="inline-block mt-2 bg-sage-light text-sage text-sm font-bold px-3 py-1 rounded-full" data-id="element-127">
                  ¡Ahorra 66%!
                </span>
              </div>

              <Button className="mx-auto lg:mx-0" href="#precio" data-id="element-128">
                ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
              </Button>

              <div className="mt-6 bg-cream border border-cream-dark rounded-2xl p-6 text-center max-w-md mx-auto lg:mx-0" data-id="element-129">
                <ShieldCheck className="w-8 h-8 text-sage mx-auto mb-3" data-id="element-130" />
                <h4 className="font-bold text-brown mb-2 text-lg" data-id="element-131">
                  Garantía de 7 Días Sin Riesgo
                </h4>
                <p className="text-sm text-brown-light leading-relaxed" data-id="element-132">
                  Si en los próximos 7 días sientes que el Plan de 21 Días de
                  Vitalidad no fue para ti, te devolvemos cada centavo. Sin
                  preguntas. Sin burocracia. Tu confianza vale más que tu
                  dinero.
                </p>
              </div>

              <p className="mt-6 text-sm text-center lg:text-left text-brown-light/80" data-id="element-133">
                Acceso instantáneo tras la compra. Tu nueva vitalidad comienza
                mañana mismo.
              </p>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none relative" data-id="element-134">
            <FadeIn delay={0.4} data-id="element-135">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brown/10 aspect-[4/5] lg:aspect-auto lg:h-[600px]" data-id="element-136">
                <img src="https://cdn.magicpatterns.com/uploads/9G6aWdx1gpXNMEYmywpptz/Plan_21_Dias_de_Vitalidad_Menopausica.png" alt="Plan de 21 Días de Vitalidad Menopáusica en una tablet" className="w-full h-full object-cover" data-id="element-137" />
                <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent mix-blend-multiply" data-id="element-138"></div>
              </div>

              {/* Floating badge */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.8,
              type: 'spring'
            }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl flex items-center gap-4" data-id="element-139">
                <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center text-sage" data-id="element-140">
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-141">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-142" />
                  </svg>
                </div>
                <div data-id="element-143">
                  <p className="text-sm font-bold text-brown" data-id="element-144">
                    Energía Estable
                  </p>
                  <p className="text-xs text-brown-light" data-id="element-145">En solo 21 días</p>
                </div>
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};